<template>
  <div style="background: #efefef; width: 100%">
    <v-card v-if="userCS.id && !userCSNotFound && !userCSError">
      <v-list two-line subheader>
        <v-subheader class="grey lighten-3">Dados da Contratação</v-subheader>
        <v-divider></v-divider>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title
              >Cliente desde (Assinado em)</v-list-tile-sub-title
            >
            <v-list-tile-title>{{
              userCS.signedcontract_at
                ? userCS.signedcontract_at
                : userCS.created_at | formatData
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Vendido por</v-list-tile-sub-title>
            <v-list-tile-title>
              {{
                userCS.signedcontract_partner
                  ? userCS.signedcontract_partner
                  : "online"
              }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <div v-if="loadingPermission" class="text-center">
              <v-progress-circular
                :width="2"
                :size="20"
                color="grey ligthen-1"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-layout v-else row justify-end>
              <v-flex md6>
                <v-btn
                  v-if="hasPermissionToChangeSeller"
                  icon
                  ripple
                  @click="openEditSellerDialog()"
                >
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex md6 v-if="changeSellerHistory">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="showChangeSellerHistory = true"
                    >
                      <v-icon dark right color="grey lighten-1">
                        mdi-format-list-bulleted
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar histórico</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile
          avatar
          v-if="
            userCS.signedcontract_source &&
            !['online', 'enercred', 'Correios'].includes(
              userCS.signedcontract_source,
            )
          "
        >
          <v-list-tile-content>
            <v-list-tile-sub-title>Parceiro</v-list-tile-sub-title>
            <v-list-tile-title>{{ partnerName }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Método de Pagamento</v-list-tile-sub-title>
            <v-list-tile-title>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success">{{
                    userCS.payment_type | formatPaymentTypeIcon
                  }}</v-icon>
                </template>
                <span>{{ userCS.payment_type | formatPaymentType }}</span>
              </v-tooltip>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout row>
              <v-btn
                icon
                riple
                :href="`https://cadastro.juntosenergia.com.br/mudar-metodo-pagamento?email=${userCS.email}`"
                target="_blank"
              >
                <v-icon right color="grey lighten-1">credit_score</v-icon>
              </v-btn>
              <v-btn
                v-if="permissions.edit_customer"
                icon
                ripple
                @click="
                  editDialog = true;
                  editTarget = 'payment_type';
                "
              >
                <v-icon color="grey lighten-1">edit</v-icon>
              </v-btn>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar v-if="!consumerUnit.contract_id">
          <v-list-tile-content>
            <v-list-tile-sub-title>Contratos</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout>
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn flat icon v-on="on" block color="tertiary" small>
                    <v-icon right>email</v-icon>
                    <!-- Ações -->
                  </v-btn>
                </template>
                <v-list>
                  <!-- Baixar Contrato -->
                  <v-list-tile @click.prevent="downloadContracts()">
                    <v-list-tile-action>
                      <v-icon left>download</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Baixar</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-subheader class="grey lighten-3">Dados Cadastrais</v-subheader>
        <v-divider></v-divider>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>E-mail</v-list-tile-sub-title>
            <v-list-tile-title>{{ userCS.email }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout align-center justify-end row fill-height>
              <v-flex xs12 md6>
                <v-btn icon ripple @click="copyText(userCS.email)">
                  <v-icon color="grey lighten-1">content_copy</v-icon>
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="userCS.emails_old && userCS.emails_old.length > 0"
              >
                <v-btn icon ripple @click="emailsListDialog = true">
                  <v-icon color="grey lighten-1">view_list</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Telefone</v-list-tile-sub-title>
            <v-list-tile-title>
              {{ userCS.phone }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout align-center justify-end row fill-height>
              <v-flex xs12 md4>
                <v-btn icon riple @click="runCall()">
                  <v-icon right color="success">phone</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn
                  v-if="permissions.edit_customer"
                  icon
                  ripple
                  @click="
                    editDialog = true;
                    editTarget = 'phone';
                  "
                >
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md4
                v-if="userCS.phones_old && userCS.phones_old.length > 0"
              >
                <v-btn icon ripple @click="phonesListDialog = true">
                  <v-icon color="grey lighten-1">view_list</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Endereço</v-list-tile-sub-title>
            <v-list-tile-title>
              <div v-html="address" />
            </v-list-tile-title>
            <v-list-tile-title>
              <div v-html="address_complement" />
            </v-list-tile-title>
            <v-list-tile-title>
              <div v-html="address_postalcode" />
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action
            v-if="userCS.address && permissions.edit_customer"
            style="min-width: max-content !important"
          >
            <v-btn icon ripple @click="editAddressDialog = true">
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar v-if="userCS.person_type === 'pf'">
          <v-list-tile-content>
            <v-list-tile-sub-title>Sexo</v-list-tile-sub-title>
            <v-list-tile-title>{{ userCS.gender }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="permissions.edit_customer">
            <v-btn
              icon
              ripple
              @click="
                editDialog = true;
                editTarget = 'gender';
              "
            >
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar v-if="userCS.person_type === 'pf'">
          <v-list-tile-content>
            <v-list-tile-sub-title>Data de Nascimento</v-list-tile-sub-title>
            <v-list-tile-title>{{
              userCS.date_of_birth | formatData
            }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="permissions.edit_customer">
            <v-btn
              icon
              ripple
              @click="
                editDialog = true;
                editTarget = 'date_of_birth';
              "
            >
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>ID</v-list-tile-sub-title>
            <v-list-tile-title>{{ userCS.id }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Huggy ID</v-list-tile-sub-title>
            <v-list-tile-title
              ><a
                target="_blank"
                :href="
                  'https://www.huggy.app/panel/contacts/' + userCS.huggy_id
                "
                >{{ userCS.huggy_id }}</a
              ></v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile-action>
            <v-layout align-center justify-end row fill-height>
              <v-flex xs12 md6>
                <v-btn
                  v-if="permissions.edit_customer"
                  icon
                  ripple
                  @click="
                    editDialog = true;
                    editTarget = 'huggy_id';
                  "
                >
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="userCS.huggyIDs_old && userCS.huggyIDs_old.length > 0"
              >
                <v-btn icon ripple @click="huggyIDsListDialog = true">
                  <v-icon color="grey lighten-1">view_list</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile
          avatar
          v-if="!this.user.group.includes('external_collection')"
        >
          <v-list-tile-content>
            <v-list-tile-sub-title>Documentos do membro</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon ripple @click="showDocumentModal(userCS)">
              <v-icon color="grey lighten-1">view_list</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Indicado por</v-list-tile-sub-title>
            <v-list-tile-title>
              {{ userCS.promo_code || "Sem Indicação" }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="permissions.referral">
            <v-btn
              v-if="!userCS.promo_code"
              icon
              ripple
              @click="indicationDialog = true"
            >
              <v-icon color="grey lighten-1">edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title>Observação de Venda</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
              v-if="userCS.sales_observation"
              icon
              ripple
              @click="salesObservationDialog = true"
            >
              <v-icon color="grey lighten-1">view_list</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-divider></v-divider>
    </v-card>
    <v-card v-if="userCSNotFound">
      <v-layout column fill-height>
        <v-card-title> Usuário não encontrado </v-card-title>
      </v-layout>
    </v-card>
    <v-card v-if="userCSError" color="red">
      <v-layout column fill-height>
        <v-card-title> Ocorreu algum erro ao buscar o usuários </v-card-title>
        <v-card-subtitle>
          {{ userCSError }}
        </v-card-subtitle>
      </v-layout>
    </v-card>

    <DocumentModal ref="documentModal" />

    <v-dialog
      v-if="userCS.address"
      v-model="editAddressDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar endereço do membro</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="userCS.address.postal_code"
                  label="CEP"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newPostalCode"
                  label="Novo CEP"
                  :hint="'Informe o CEP'"
                  mask="#####-###"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="userCS.address.address"
                  label="Endereço"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newAddress"
                  label="Novo Endereço"
                  :hint="'Informe o Endereço'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="userCS.address.address_number"
                  label="Número"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newAddressNumber"
                  label="Novo Número"
                  :hint="'Informe o Número'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="userCS.address.address_complement"
                  label="Complemento"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newAddressComplement"
                  label="Novo Complemento"
                  :hint="'Informe o Complemento'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="userCS.address.district"
                  label="Bairro"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newDistrict"
                  label="Bairro"
                  :hint="'Informe o Bairro'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="userCS.address.city"
                  label="Cidade"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field
                  v-model="newCity"
                  label="Cidade"
                  :hint="'Informe a Cidade'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="editAddressDialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeAddress"
            :disabled="loadingChange"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar informação do membro</span>
        </v-card-title>
        <v-card-text>
          <v-form :ref="editTarget" v-if="editTarget == 'phone'">
            <v-text-field
              label="Telefone"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              mask="+## (##) #####-####"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo Telefone"
              prepend-icon="star"
              name="editValue"
              hint="Somente números"
              counter
              :rules="[
                (v) => !!v || 'Por favor, informe o telefone.',
                (v) => v.length >= 11 || 'O número de telefone não é válido!',
              ]"
              required
              v-model="editValue"
              :mask="
                '(##) ####' + (editValue.length > 10 ? '#-####' : '-#####')
              "
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'ID_document'">
            <v-text-field
              label="Documento"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo Documento"
              prepend-icon="star"
              name="editValue"
              counter
              :rules="[
                (v) => !!v || 'Por favor, informe o documento.',
                (v) => v.length >= 3 || 'O número de documento não é válido!',
              ]"
              required
              v-model="editValue"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'gender'">
            <v-text-field
              label="Gênero"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              disabled
            ></v-text-field>
            <v-select
              label="Novo Gênero"
              prepend-icon="star"
              :items="['M', 'F']"
              v-model="editValue"
              required
              :rules="[(v) => !!v || 'Por favor, informe o gênero.']"
            ></v-select>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'date_of_birth'">
            <v-text-field
              label="Data de Nascimento"
              prepend-icon="star_border"
              :value="userCS[editTarget] | formatData"
              disabled
            ></v-text-field>

            <v-dialog
              ref="dateDialog"
              v-model="modal"
              :return-value.sync="editValue"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editValue"
                  label="Nova Data de Nascimento"
                  prepend-icon="star"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker dark v-model="editValue" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.dateDialog.save(editValue)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget == 'huggy_id'">
            <v-text-field
              label="Huggy ID"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              disabled
            ></v-text-field>
            <v-text-field
              label="Novo Huggy ID"
              prepend-icon="star"
              name="editValue"
              hint="Somente números"
              counter
              :rules="[(v) => !!v || 'Por favor, informe o id.']"
              required
              v-model="editValue"
            ></v-text-field>
          </v-form>
          <v-form :ref="editTarget" v-if="editTarget === 'payment_type'">
            <v-text-field
              label="Método de Pagamento Atual"
              prepend-icon="star_border"
              :value="userCS[editTarget]"
              disabled
            ></v-text-field>
            <v-radio-group
              v-model="editValue"
              label="Novo Método de Pagamento"
              required
            >
              <v-radio label="Pix" value="pix"></v-radio>
              <v-radio label="Boleto" value="boleto"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="
              editDialog = false;
              editValue = '';
            "
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="changeUserData"
            :disabled="!permissions.edit_customer"
            :loading="loadingChange"
            >Alterar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sendContractsEmailDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Enviar email com contratos</span>
        </v-card-title>
        <v-card-text>
          Será enviado um email para o membro em {{ userCS.email }} com todos os
          contratos, referentes às unidades consumidoras.
        </v-card-text>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="sendContractsEmailDialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="sendContractsEmail"
            :disabled="loadingChange"
            :loading="loadingChange"
            >Enviar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="downloadContractsDialog"
      max-width="500px"
      persistent
      lazy
    >
      <v-card v-if="contracts && contracts.length > 0">
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Informe o contrato que deseja baixar</span>
        </v-card-title>
        <v-list subheader>
          <v-subheader>Contratos</v-subheader>
          <v-list-tile
            v-for="contract in contracts"
            :key="contract.consumer_unit_id"
          >
            <v-list-tile-content>
              <v-list-tile-title
                :v-html="contract.consumer_unit_id"
              ></v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon
                color="teal"
                @click="
                  downloadResumePdf(
                    contract.contract_url,
                    contract.consumer_unit_id,
                  )
                "
                >download</v-icon
              >
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="downloadContractsDialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            flat
            @click="sendContractsEmail"
            :disabled="loadingChange"
            :loading="loadingChange"
            >Enviar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="emailsListDialog" max-width="500px" persistent lazy>
      <v-card v-if="userCS.emails_old && userCS.emails_old.length > 0">
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="headline"
                >Lista dos emails anteriores do membro</span
              >
            </v-flex>
            <v-flex xs12 md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="emailsListDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-list>
          <v-list-tile v-for="email in userCS.emails_old" :key="email">
            <v-list-tile-content>
              <v-list-tile-title>{{ email }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple @click="copyText(email)">
                <v-icon color="grey lighten-1">content_copy</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="phonesListDialog" max-width="500px" persistent lazy>
      <v-card v-if="userCS.phones_old && userCS.phones_old.length > 0">
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="headline"
                >Lista dos telefones anteriores do membro</span
              >
            </v-flex>
            <v-flex xs12 md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="phonesListDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-list>
          <v-list-tile v-for="phone in userCS.phones_old" :key="phone">
            <v-list-tile-content>
              <v-list-tile-title>{{ phone }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="huggyIDsListDialog" max-width="500px" persistent lazy>
      <v-card v-if="userCS.huggyIDs_old && userCS.huggyIDs_old.length > 0">
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="headline"
                >Lista dos huggy IDs anteriores do membro</span
              >
            </v-flex>
            <v-flex xs12 md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="huggyIDsListDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-list>
          <v-list-tile v-for="huggyID in userCS.huggyIDs_old" :key="huggyID">
            <v-list-tile-content>
              <v-list-tile-title
                ><a :href="'https://www.huggy.app/panel/contacts/' + huggyID">{{
                  huggyID
                }}</a></v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="pipedriveIDsListDialog"
      max-width="500px"
      persistent
      lazy
    >
      <v-card
        v-if="userCS.pipedriveIDs_old && userCS.pipedriveIDs_old.length > 0"
      >
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="headline"
                >Lista dos pipedrive IDs anteriores do membro</span
              >
            </v-flex>
            <v-flex xs12 md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="pipedriveIDsListDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-list>
          <v-list-tile
            v-for="pipedriveID in userCS.pipedriveIDs_old"
            :key="pipedriveID"
          >
            <v-list-tile-content>
              <v-list-tile-title
                ><a
                  :href="
                    'https://eletronenergy.pipedrive.com/person/' + pipedriveID
                  "
                  >{{ pipedriveID }}</a
                ></v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="idPhotoDialog" max-width="500px" persistent lazy>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="headline"
                >Lista das fotos dos documentos do membro</span
              >
            </v-flex>
            <v-flex xs12 md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="idPhotoDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-list>
          <v-list-tile v-for="photo in document_photo" :key="photo.name">
            <v-list-tile-content>
              <v-list-tile-title>
                <a :href="photo.url" target="_blank">{{ photo.name }} </a>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="showDeletePhotoModal(photo.name, userCS.id)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-list-tile-action>
            <delete-photo-modal
              :showDialog="showDeletePhoto"
              :closeView="closeView"
              :updateList="updateList"
              :idPhoto="id_photo"
              :customer_id="customer_id"
              @clearForm="clearForm()"
            />
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="indicationDialog" max-width="500px" persistent lazy>
      <v-card>
        <v-card-title class="headline grey lighten-3 py-1" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="align-center">Indicação</span>
            </v-flex>
            <v-flex md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="indicationDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-form>
          <v-layout wrap class="pa-3">
            <v-text-field
              v-model="indicatorEmail"
              label="Email do indicador"
              prepend-icon="email"
              name="indicator_email"
              filled
              rounded
              dense
              @keyup="lowerCase"
            />
            <v-btn
              flat
              color="success"
              @click.prevent="saveIndication(indicatorEmail)"
              :loading="loadingChange"
              :disabled="indicatorEmail.trim() === ''"
              type="submit"
            >
              Salvar
            </v-btn>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="salesObservationDialog"
      max-width="500px"
      persistent
      lazy
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-center justify-end row fill-height>
            <v-flex xs12 md11>
              <span class="headline">Observação</span>
            </v-flex>
            <v-flex xs12 md1>
              <v-btn
                icon
                dark
                flat
                color="error"
                @click="salesObservationDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="userCS.sales_observation"
            auto-grow
            box
            readonly
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="editSeller"
      v-model="editSeller"
      max-width="500px"
      persistent
      lazy
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">Editar vendedor do membro</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="changeSellerForm"
            v-model="changeSellerForm"
            lazy-validation
          >
            <v-text-field
              label="Vendedor"
              prepend-icon="star_border"
              :value="userCS.signedcontract_partner"
              disabled
            ></v-text-field>
            <v-autocomplete
              :items="sellers"
              prepend-icon="star"
              item-text="email"
              return-object
              label="Vendedor"
              v-model="newSeller"
              :rules="[rules.requiredSeller]"
              required
            ></v-autocomplete>
            <v-textarea
              v-model="changeSellerReason"
              auto-grow
              box
              label="Motivo"
              placeholder="Digite motivo da alteração"
              rows="1"
              :rules="[rules.requiredReason]"
              required
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions class="align">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="editSeller = false">
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            flat
            :disabled="!changeSellerForm"
            @click="changeUserSeller"
          >
            Alterar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="changeSellerHistory"
      v-model="showChangeSellerHistory"
      persistent
      lazy
      max-width="1000px"
    >
      <v-card class="d-flex dialog-container" style="flex-direction: column">
        <v-card-title class="title font-weight-bold pb-0 dialog-header">
          Histórico de alterações de vendedor do usuário
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            flat
            color="error"
            @click="showChangeSellerHistory = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-timeline align-top dense>
            <v-timeline-item
              v-for="(history, i) in changeSellerHistory"
              :key="i"
              color="#7D3DFF"
              small
            >
              <v-layout pt-2>
                <v-flex xs4>
                  <v-layout column>
                    <v-flex>
                      <span
                        :class="`subheading font-weight-bold black--text`"
                        >{{ history.created_at | formatDateTime }}</span
                      >
                    </v-flex>
                    <v-flex>
                      <span
                        :class="`caption font-weight-bold black--text`"
                        v-text="`Alterado por: `"
                      ></span>
                      <span
                        :class="`caption font-weight-light black--text`"
                        v-text="history.agent.email"
                      ></span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <span :class="`font-weight-bold mb-3 black--text`">
                    {{ history.old_values.signedcontract_partner }}
                  </span>
                  <v-icon color="#7D3DFF"> east </v-icon>
                  <span :class="`font-weight-bold mb-3 black--text`">
                    {{ history.new_values.signedcontract_partner }}
                  </span>
                  <div v-if="history.reason">
                    <span
                      :class="`caption font-weight-bold black--text`"
                      v-text="`Motivo: `"
                    ></span>
                    <span
                      :class="`caption font-weight-light black--text`"
                      v-text="history.reason"
                    ></span>
                  </div>
                </v-flex>
              </v-layout>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.value"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import dayjs from "dayjs";
import firebase from "firebase";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import firestore from "../../../firebase/firestore";
import { hasPermissionMixin } from "../../../mixin/permissionsMixin.js";
import { uploadData } from "../../../services/sales";
import {
  downloadContracts,
  getUserByEmail,
  sendContractsEmail,
  updateUser,
} from "../../../services/users";
import {
  getAllSellers,
  getUserChangelog,
  updateUserSeller,
} from "../../../services/users.js";
import { call } from "../../../utils/call";
import { clearPhone } from "../../../utils/utils";
import DeletePhotoModal from "../../sales/form/DeletePhotoModal.vue";
import DocumentModal from "../../sales/kanban/DocumentModal.vue";

export default {
  components: { DeletePhotoModal, DocumentModal },

  mixins: [hasPermissionMixin],

  data() {
    return {
      id_photo: "",
      customer_id: "",
      showDeletePhoto: false,
      idPhoto: [
        {
          name: "",
          data: null,
        },
      ],
      availableFormats: ["jpg", "jpeg", "png", "pdf"],
      date: "",
      modal: false,
      menu: false,
      loadingChange: false,
      sendContractsEmailDialog: false,
      editDialog: false,
      editAddressDialog: false,
      editTarget: "",
      editValue: "",
      newPostalCode: "",
      newAddress: "",
      newAddressNumber: "",
      newAddressComplement: "",
      newDistrict: "",
      newCity: "",
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
      contracts: [],
      downloadContractsDialog: false,
      emailsListDialog: false,
      phonesListDialog: false,
      huggyIDsListDialog: false,
      pipedriveIDsListDialog: false,
      idPhotoDialog: false,
      document_photo: [],
      energy_bill: [],
      indicationDialog: false,
      indicatorEmail: "",
      indicator_name: "",
      salesObservationDialog: false,
      partnerName: "",
      rules: {
        requiredSeller: (v) => !!v || "O campo de vendedor é obrigatório.",
        requiredReason: (v) => !!v || "O campo de motivo é obrigatório.",
      },
      changeSellerForm: true,
      editSeller: false,
      sellers: [],
      newSeller: null,
      changeSellerReason: "",
      hasPermissionToChangeSeller: false,
      showChangeSellerHistory: false,
      changeSellerHistory: null,
      loadingPermission: false,
    };
  },
  async created() {
    this.loadingPermission = true;
    const changelog = await getUserChangelog(this.userCS.id);
    const change_seller_history = changelog.filter((change) =>
      change.fields_changed.includes("signedcontract_partner"),
    );

    if (change_seller_history.length > 0)
      this.changeSellerHistory = change_seller_history;
    else this.changeSellerHistory = null;

    this.hasPermissionToChangeSeller =
      await this.hasPermission("change_seller");
    this.loadingPermission = false;
  },

  async mounted() {
    if (
      this.partnerId &&
      !["online", "enercred", "Correios"].includes(this.partnerId)
    ) {
      this.partnerName =
        (await this.getPartnerName(this.partnerId)) || this.partnerId;
    }
    this.document_photo = await this.getIdPhotos(this.userCS.id);
    this.energy_bill = await this.getIdPhotos(this.userCS.id);
  },

  computed: {
    ...mapGetters("cs", ["userCS", "userCSError", "userCSNotFound"]),
    ...mapState(["user", "permissions"]),
    ...mapGetters(["loggedUser"]),

    consumerUnit() {
      if (this.$store.state && this.$store.state.cs.consumerUnit)
        return this.$store.state.cs.consumerUnit;
      else return null;
    },

    address() {
      if (!this.userCS.address) return "";
      let address = this.userCS.address.address;

      if (this.userCS.address && this.userCS.address.address_number)
        address = address + ", " + this.userCS.address.address_number;

      if (this.userCS.address && this.userCS.address.address_complement)
        address = address + " - " + this.userCS.address.address_complement;

      return address;
    },
    address_complement() {
      if (!this.userCS.address) return "";
      if (
        (this.userCS.address && !this.userCS.address.district) ||
        this.userCS.address === ""
      )
        return "";
      let address = this.userCS.address.district.toUpperCase();

      if (this.userCS.address && this.userCS.address.city)
        address = address + ", " + this.userCS.address.city.toUpperCase();

      if (
        this.userCS.address &&
        this.userCS.address.state &&
        this.userCS.address.state.initials
      )
        address =
          address + " - " + this.userCS.address.state.initials.toUpperCase();

      return address;
    },
    address_postalcode() {
      if (!this.userCS.address) return "";
      return this.userCS && this.userCS.address
        ? this.userCS.address.postal_code
        : "";
    },
    phone() {
      return clearPhone(this.userCS.phone);
    },

    partnerId() {
      return this.userCS?.signedcontract_source ?? "";
    },
  },

  methods: {
    ...mapActions("cs", ["getIdPhotos", "getPartnerName"]),

    removeFile() {
      if (this.idPhoto.length == 1) {
        this.idPhoto = [
          {
            name: "",
            data: null,
          },
        ];
        this.$emit("pickedPhotos", []);
      } else {
        this.idPhoto.pop();
        this.$emit("pickedPhotos", this.idPhoto);
      }
    },
    pickIdPhoto() {
      this.$refs.idPhoto.click();
    },
    async pickedPhotos(event) {
      const photosFiles = event.target.files;
      for (const photo of photosFiles) {
        if (photo !== undefined) {
          let extension = photo.name.split(".")[1].toLowerCase();
          if (!this.availableFormats.includes(extension)) {
            this.showSnackBar(
              "O arquivo deve ser PDF, PNG, JPG ou JPEG!",
              "top",
              "red",
            );
            return;
          }
          if (!this.idPhoto[0].name) {
            this.idPhoto = [];
          }
          this.idPhoto.push({
            name: photo.name,
            data: photo,
          });
        }
      }
      try {
        await uploadData({ id: this.userCS.id, data: this.idPhoto });
        this.showSnackBar("Arquivo anexado com sucesso", "top", "green");
      } catch {
        this.showSnackBar(
          "Erro ao anexar arquivo, tente novamente!",
          "top",
          "red",
        );
      }
    },

    downloadContracts() {
      downloadContracts(this.userCS.id)
        .then((contracts) => {
          this.contracts = contracts;
          if (contracts.length > 1) {
            this.downloadContractsDialog = true;
          } else if (contracts.length === 1) {
            this.downloadResumePdf(
              contracts[0].contract_url,
              contracts[0].consumer_unit_id,
            );
          } else {
            this.showSnackBar(
              "Não foi encontrado nenhum contrato para este membro!",
              "top",
              "orange",
            );
          }
        })
        .catch((err) => {
          this.showSnackBar(
            "Erro ao acessar contratos. Por favor tente novamente mais tarde. " +
              err,
            "top",
            "red",
          );
        });
    },

    dowloadFile(url) {
      let s = firebase.storage().refFromURL(url);
      console.log(s);
    },
    downloadResumePdf(url) {
      const resumeRef = firebase.storage().refFromURL(url);
      resumeRef
        .getDownloadURL()
        .then((adress) => {
          const anchor = document.createElement("a");
          anchor.href = adress;
          anchor.target = "_blank";
          anchor.click();
          document.body.removeChild(anchor);
        })
        .catch((error) => {
          switch (error.code) {
            case "storage/object-not-found":
              this.showSnackBar(
                "Não foi encontrado nenhum contrato para este membro!",
                "top",
                "red",
              );
              break;

            case "storage/unauthorized":
              this.showSnackBar(
                "Você não tem permissão para acessar este contrato!",
                "top",
                "red",
              );
              break;

            case "storage/canceled":
              this.showSnackBar(
                "Você cancelou o download do contrato!",
                "top",
                "red",
              );
              break;

            case "storage/unknown":
              this.showSnackBar(
                "Erro desconhecido ao tentar baixar o contrato!",
                "top",
                "red",
              );
              break;
            default:
              break;
          }
        });
    },
    sendContractsEmail() {
      this.loadingChange = true;
      sendContractsEmail(this.userCS.id, this.userCS.email)
        .then(() => {
          this.sendContractsEmailDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Pedido de envio de email com contratos solicitado com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.sendContractsEmailDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao solicitar o envio de email. " + err.response.data,
            "top",
            "red",
          );
        });
    },
    async changeUserData() {
      this.loadingChange = true;
      const permission = await this.hasPermission("edit_customer");

      if (!permission) {
        this.showSnackBar(
          "Usuário sem permissão para realizar essa ação",
          "top",
          "red",
        );
        this.loadingChange = false;
        return false;
      }

      if (!this.$refs[this.editTarget].validate()) {
        return false;
      }

      let data;
      let phones_old = this.userCS.phones_old || [];
      let huggyIDs_old = this.userCS.huggyIDs_old || [];
      let pipedriveIDs_old = this.userCS.pipedriveIDs_old || [];

      if (this.editTarget == "date_of_birth")
        data = { [this.editTarget]: new Date(this.editValue) };
      else if (this.editTarget == "phone") {
        phones_old.push(this.userCS.phone);

        data = {
          [this.editTarget]: "+55" + this.editValue,
          last_agent_id: this.user.id,
          last_agent_name: this.user.name,
          last_agent_email: this.user.email,
          last_agent_phone_update: this.user.name,
          phones_old: phones_old,
        };
      } else if (this.editTarget == "huggy_id") {
        if (this.userCS.huggy_id) {
          huggyIDs_old.push(this.userCS.huggy_id);
        }
        data = {
          [this.editTarget]: this.editValue,
          last_agent_id: this.user.id,
          last_agent_name: this.user.name,
          last_agent_email: this.user.email,
          huggyIDs_old: huggyIDs_old,
        };
      } else if (this.editTarget == "pipedrive_id") {
        if (this.userCS.pipedrive_id) {
          pipedriveIDs_old.push(this.userCS.pipedrive_id);
        }
        data = {
          [this.editTarget]: this.editValue,
          last_agent_id: this.user.id,
          last_agent_name: this.user.name,
          last_agent_email: this.user.email,
          pipedriveIDs_old: pipedriveIDs_old,
        };
      } else
        data = {
          [this.editTarget]: this.editValue,
          last_agent_id: this.user.id,
          last_agent_name: this.user.name,
          last_agent_email: this.user.email,
        };
      updateUser(this.userCS.id, data)
        .then(() => {
          this.editDialog = false;
          this.editTarget = "";
          this.editValue = "";
          this.loadingChange = false;
          this.showSnackBar("Campo alterado com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.editDialog = false;
          this.editTarget = "";
          this.editValue = "";
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar campo. Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        });
    },
    changeAddress() {
      this.loadingChange = true;
      let postal_code = this.userCS.address
        ? this.userCS.address.postal_code
        : "";
      let data = {
        address: {
          address:
            this.newAddress != ""
              ? this.newAddress
              : this.userCS.address.address || null,
          address_complement:
            this.newAddressComplement != ""
              ? this.newAddressComplement
              : this.userCS.address.address_complement || null,
          address_number:
            this.newAddressNumber != ""
              ? this.newAddressNumber
              : this.userCS.address.address_number || null,
          city:
            this.newCity != ""
              ? this.newCity
              : this.userCS.address.city || null,
          district:
            this.newDistrict != ""
              ? this.newDistrict
              : this.userCS.address.district || null,
          postal_code:
            this.newPostalCode != "" ? this.newPostalCode : postal_code || null,
          country: {
            initials: "BR",
            name: "Brasil",
          },
          state: {
            initials: "MG",
            name: "Minas Gerais",
          },
        },
        last_agent_id: this.user.id,
        last_agent_name: this.user.name,
        last_agent_email: this.user.email,
      };
      updateUser(this.userCS.id, data)
        .then(() => {
          this.editAddressDialog = false;
          this.newPostalCode = "";
          this.newAddress = "";
          this.newAddressNumber = "";
          this.newAddressComplement = "";
          this.newDistrict = "";
          this.newCity = "";
          this.loadingChange = false;
          this.showSnackBar("Campo(s) alterado com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.editAddressDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar campo(s). Tente novamente mais tarde. " + err,
            "top",
            "red",
          );
          console.error(err);
        });
    },
    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },
    copyText(text) {
      navigator.clipboard.writeText(text);
      this.showSnackBar("Copiado para área de transferência", "top", "green");
    },

    async saveIndication(email) {
      this.loadingChange = true;
      const permission = await this.hasPermission("referral");

      if (!permission) {
        this.showSnackBar(
          "Usuário sem permissão para realizar essa ação",
          "top",
          "red",
        );
        this.indicationDialog = false;
        this.loadingChange = false;
        return false;
      }

      if (this.userCS.email === this.indicatorEmail) {
        this.loadingChange = false;
        this.showSnackBar(
          "Não é possível fazer uma auto indicação.",
          "top",
          "warning",
        );
        return;
      }

      getUserByEmail(email).then(async (res) => {
        if (res.size > 0 && res.docs[0].data().name) {
          const lead = (
            await firestore.collection("leads").doc(this.userCS.email).get()
          ).data();
          if (!lead.promo_code_used) {
            await firestore.collection("users").doc(this.userCS.id).update({
              promo_code: this.indicatorEmail,
              manual_referral: true,
              referral_applicant: this.user.email,
            });
            this.showSnackBar("Indicação feita com sucesso!", "top", "green");
            this.indicationDialog = false;
          } else {
            this.showSnackBar(
              "Erro ao realizar indicação, lead já foi indicado.",
              "top",
              "red",
            );
          }
        } else {
          this.showSnackBar("O email do indicador não é válido.", "top", "red");
          this.indicationDialog = false;
        }
        this.loadingChange = false;
      });
    },

    showDeletePhotoModal(name, customer_id) {
      this.showDeletePhoto = !this.showDeletePhoto;
      this.id_photo = name;
      this.customer_id = customer_id;
    },

    closeView() {
      this.showDeletePhoto = !this.showDeletePhoto;
      this.$emit("closeDialog");
    },

    clearForm() {
      this.updateComponent++;
    },

    async updateList() {
      this.document_photo = await this.getIdPhotos(this.userCS.id);
    },

    lowerCase() {
      this.indicatorEmail = this.indicatorEmail
        ? this.indicatorEmail.toLowerCase()
        : "";
    },

    async runCall() {
      try {
        const user = await firestore
          .collection("users")
          .where("email", "==", this.user.email)
          .limit(1)
          .get();
        let ramal, from;
        if (user.size > 0) {
          ramal = user.docs[0].data().extension;
          from = user.docs[0].data().name;
        }
        if (!ramal) {
          console.error("user don't have extension");
          this.showSnackBar("Ramal não registrado", "top", "red");
          return;
        }
        const number = this.userCS.phone;
        const to = this.userCS.name;

        return await call(number, ramal, from, to);
      } catch (err) {
        console.error(err);
        this.showSnackBar("Plugin da API4COM deve estar aberto", "top", "red");
      }
    },

    showDocumentModal(customer) {
      this.$refs.documentModal.showDocumentModal(customer);
    },

    async formatPartner(id) {
      const partner = await this.getPartnerName(id);
      this.partnerName = partner || "";
    },

    async openEditSellerDialog() {
      this.sellers = await getAllSellers();
      this.editSeller = true;
    },

    async changeUserSeller() {
      if (this.$refs.changeSellerForm.validate()) {
        const res = await updateUserSeller(
          this.userCS.id,
          this.newSeller,
          this.changeSellerReason.trim() || undefined,
        );

        if (res) {
          this.showSnackBar("Vendedor alterado com sucesso!", "top", "green");
          this.changeSellerHistory = (
            await getUserChangelog(this.userCS.id)
          ).filter((change) =>
            change.fields_changed.includes("signedcontract_partner"),
          );
        } else {
          this.showSnackBar(
            "Não foi possível alterar o vendedor.",
            "top",
            "red",
          );
        }
        this.editSeller = false;
      }
    },
  },

  watch: {
    async partnerId() {
      this.partnerName =
        (await this.getPartnerName(this.partnerId)) || this.partnerId;
    },

    editSeller() {
      if (!this.editSeller) {
        this.$refs.changeSellerForm.reset();
      }
    },
  },

  filters: {
    formatDateTime(value) {
      try {
        if (!value) return "";
        if (value._seconds)
          return dayjs(new Date(value._seconds * 1000)).format(
            "DD/MM/YYYY HH:mm",
          );
        if (value.__zone_symbol__value)
          return dayjs(new Date(value.__zone_symbol__value)).format(
            "DD/MM/YYYY HH:mm",
          );
        if (typeof value === "string")
          return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
        if (typeof value === "object")
          return moment(value.toDate()).format("DD/MM/YYYY HH:mm");
        return value;
      } catch (e) {
        return "";
      }
    },

    formatData(value) {
      try {
        if (!value) return "";
        if (value._seconds)
          return moment(new Date(value._seconds * 1000)).format("DD/MM/YYYY");
        if (value.__zone_symbol__value)
          return moment(new Date(value.__zone_symbol__value)).format(
            "DD/MM/YYYY",
          );
        if (typeof value === "string")
          return moment(new Date(value)).format("DD/MM/YYYY");
        if (typeof value === "object")
          return moment(value.toDate()).format("DD/MM/YYYY");
        return value;
      } catch (e) {
        return "";
      }
    },
  },
};
</script>
